import * as exifr from "exifr";

export interface ExifData {
  latitude?: number;
  longitude?: number;
  dateTime?: string;
  camera?: string;
  lens?: string;
  iso?: number;
  aperture?: string;
  shutterSpeed?: string;
  focalLength?: number;
  flash?: boolean;
  orientation?: number;
}

export async function extractExifData(file: File): Promise<ExifData | null> {
  try {
    const exifData = await exifr.parse(file, {});
    /*
    gps: true,
      exif: true,
      ifd0: true,
      ifd1: true,
      */

    if (!exifData) return null;

    const result: ExifData = {};

    // GPS coordinates
    if (exifData.latitude && exifData.longitude) {
      result.latitude = exifData.latitude;
      result.longitude = exifData.longitude;
    }

    // Date and time
    if (exifData.DateTimeOriginal) {
      result.dateTime = exifData.DateTimeOriginal.toISOString();
    } else if (exifData.DateTime) {
      result.dateTime = exifData.DateTime.toISOString();
    }

    // Camera information
    if (exifData.Make && exifData.Model) {
      result.camera = `${exifData.Make} ${exifData.Model}`;
    } else if (exifData.Model) {
      result.camera = exifData.Model;
    }

    // Lens information
    if (exifData.LensMake && exifData.LensModel) {
      result.lens = `${exifData.LensMake} ${exifData.LensModel}`;
    } else if (exifData.LensModel) {
      result.lens = exifData.LensModel;
    }

    // Camera settings
    if (exifData.ISO) {
      result.iso = exifData.ISO;
    }

    if (exifData.FNumber) {
      result.aperture = `f/${exifData.FNumber}`;
    }

    if (exifData.ExposureTime) {
      if (exifData.ExposureTime >= 1) {
        result.shutterSpeed = `${exifData.ExposureTime}s`;
      } else {
        result.shutterSpeed = `1/${Math.round(1 / exifData.ExposureTime)}`;
      }
    }

    if (exifData.FocalLength) {
      result.focalLength = exifData.FocalLength;
    }

    if (exifData.Flash !== undefined) {
      result.flash = exifData.Flash > 0;
    }

    if (exifData.Orientation) {
      result.orientation = exifData.Orientation;
    }

    return result;
  } catch (error) {
    console.warn("Error extracting EXIF data:", error);
    return null;
  }
}

export function formatExifData(exifData: ExifData): Record<string, string> {
  const formatted: Record<string, string> = {};

  if (exifData.camera) formatted["Camera"] = exifData.camera;
  if (exifData.lens) formatted["Lens"] = exifData.lens;
  if (exifData.iso) formatted["ISO"] = exifData.iso.toString();
  if (exifData.aperture) formatted["Aperture"] = exifData.aperture;
  if (exifData.shutterSpeed) formatted["Shutter Speed"] = exifData.shutterSpeed;
  if (exifData.focalLength)
    formatted["Focal Length"] = `${exifData.focalLength}mm`;
  if (exifData.flash !== undefined)
    formatted["Flash"] = exifData.flash ? "Yes" : "No";

  return formatted;
}

export function getLocationFromExif(
  exifData: ExifData
): { latitude: number; longitude: number } | null {
  if (exifData.latitude && exifData.longitude) {
    return {
      latitude: exifData.latitude,
      longitude: exifData.longitude,
    };
  }
  return null;
}

export function getDateFromExif(exifData: ExifData): Date | null {
  if (exifData.dateTime) {
    return new Date(exifData.dateTime);
  }
  return null;
}
